import { ElkServiceBase, WsElk } from "./wsdl/ws_elk/v1/ws_elk";

export {
    WsElk
};

export class ElkService extends ElkServiceBase {
}
